import { getUserDetail } from "services/user/user.session.service";
import { capitalice } from "services/util/util.service";

export function getPaymentsLiterals(t: any) {
  return {
    title: t("getPaymentsLiterals.title"),
    button: t("getPaymentsLiterals.button"),
    emptySection: {
      title: t("getPaymentsLiterals.emptySection.title"),
      text: t("getPaymentsLiterals.emptySection.text"),
    },
    withContentSection: {
      title: t("getPaymentsLiterals.withContentSection.title"),
      text: t("getPaymentsLiterals.withContentSection.text"),
    },
    cardAddMore: {
      hrefLink: t("getPaymentsLiterals.cardAddMore.hrefLink"),
      disabled: t("getPaymentsLiterals.cardAddMore.disabled"),
      cardText: t("getPaymentsLiterals.cardAddMore.cardText"),
      iconType: t("getPaymentsLiterals.cardAddMore.iconType"),
    },
    expiredText: t("getPaymentsLiterals.expiredText")
  };
}

export function mapPaymentCards(methods: any, t: any,defaultCard:boolean,idMethod:any) {
  let aux: any[] = getGoogleApple(t,idMethod);
  methods.forEach((method: any) => {
    if(defaultCard==true){
      if(method?.default===true){
        aux.push(mapPaymentCard(method, t,idMethod));
      }
    }else{
      aux.push(mapPaymentCard(method, t,idMethod));
    }
  });
  return aux;
}

export function mapPaymentCard( method:any,t:any,idMethod:any){
    const { id, details } = method;
    let number = details.maskedNumber ? details.maskedNumber.split("*")[details.maskedNumber.split("*").length - 1] : "";
    return {
        id,
        default: method.default,
        title: t("literals.title"),
        type: capitalice(details.network),
        number,
        expireDate: details.expireDate,
        icon: details.network,
        //selected: method.default,
        selected: idMethod === undefined ? method.default : (method.type !== idMethod ? false : method.default),
        action:true
    }
}

function setPaymentExpireDate(sDate: string) {
  const date = new Date(sDate);
  return `${date.getMonth() + 1} / ${date.getFullYear() % 100}`;
}

export function getPaymentCards(t: any) {
  return [
    {
      id: t("getPaymentCards.0.id"),
      title: t("getPaymentCards.0.title"),
      type: t("getPaymentCards.0.type"),
      number: t("getPaymentCards.0.number"),
      icon: t("getPaymentCards.0.icon"),
      selected: t("getPaymentCards.0.selected"),
    },
    {
      id: t("getPaymentCards.1.id"),
      title: t("getPaymentCards.1.title"),
      type: t("getPaymentCards.1.type"),
      number: t("getPaymentCards.1.number"),
      icon: t("getPaymentCards.1.icon"),
      selected: t("getPaymentCards.1.selected"),
    },
  ];
}

export function getRandomCard(t: any) {
  let items = getPaymentCards(t);
  var item = items[Math.floor(Math.random() * items.length)];
  return { ...item, id: Date.now().toString() };
}

export function getDeleteCardLiterals(t: any) {
  return {
    title: t("getDeleteCardLiterals.title"),
    desc: t("getDeleteCardLiterals.desc"),
    cancelbutton: t("getDeleteCardLiterals.cancelbutton"),
    okbutton: t("getDeleteCardLiterals.okbutton"),
  };
}
export function getDeleteCardErrorLiterals(t: any) {
  return {
    title: t("getDeleteCardErrorLiterals.title"),
    desc: t("getDeleteCardErrorLiterals.desc"),
    cancelbutton: t("getDeleteCardErrorLiterals.cancelbutton"),
    okbutton: t("getDeleteCardErrorLiterals.okbutton"),
  };
}

//Funcion para comprobar si el usuario tiene rellenado su direccion 
export function checkBillingAddress() {
  let result=false, valueUserDetail=getUserDetail();
  if(valueUserDetail?.mailingAddress!=undefined ){
    result=true;
  }
  return result;
}


export function getGoogleApple(t: any,idMethod:string) {
  return[
    /*{
      id:"GOOGLE_PAY",
      default: idMethod==="GOOGLE_PAY" ?true: false,
      title: t("literals.title"),
      type: "Google Pay",
      number:"GOOGLE_PAY",
      expireDate: "",
      icon: "google_pay",
      selected:idMethod==="GOOGLE_PAY" ?true: false,
      action:false
  },
  {
    id:"APPLE_PAY",
    default: idMethod==="APPLE_PAY" ?true: false,
    title: t("literals.title"),
    type: "Apple Pay",
    number:"APPLE_PAY",
    expireDate: "",
    icon: "apple_pay",
    selected:idMethod==="APPLE_PAY" ?true: false,
    action:false
},*/
  {
    id:"GOOGLE_PAY",
    default: idMethod==="APPLE_PAY" ||idMethod==="GOOGLE_PAY" || idMethod==='X_PAY'  ?true: false,
    title: t("literals.title"),
    type: "pay_mobile",
    number:"X_PAY",
    expireDate: "",
    icon: "pay_mobile",
    selected:idMethod==="APPLE_PAY" || idMethod==="GOOGLE_PAY" || idMethod==='X_PAY' ?true: false,
    action:false
}
  ]
}

export enum typePay {
  GOOGLE = "GOOGLE_PAY",
  APPLE = "APPLE_PAY",
  CREDIT="CREDIT_CARD",
  ANONYMOUS="ANONYMOUS_CREDIT_CARD",
  XPAY='X_PAY'
}

